/* istanbul ignore file */
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { baseUrl, localhost, translationEndpoint } from './constants';
import { supportedLanguages } from './constants/i18n';

const loadPath =
  process.env.REACT_APP_USE_LOCAL_TRANSLATION === 'true' ? localhost : `${baseUrl}${translationEndpoint}`;

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    load: 'currentOnly',
    supportedLngs: supportedLanguages,
    fallbackLng: 'en-US',
    ns: ['common'],
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    maxRetries: 1,
    retryTimeout: 5000,
    backend: {
      // include &version=<version> to use specific translation version
      loadPath:
        process.env.REACT_APP_ENV === 'production'
          ? `${loadPath}?language={{lng}}&namespace={{ns}}&client=box`
          : process.env.REACT_APP_ENV === 'test'
          ? `${loadPath}?language={{lng}}&namespace={{ns}}&client=box`
          : `${loadPath}?language={{lng}}&namespace={{ns}}&client=box&version=1.2`,
    },
  });

export default i18n;
